<template>
  <div id="app">
    <router-view ref='form' class='page' />
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss">

@font-face {
  font-family: 'DefaultFont';
  src: url('/resources/muli-variablefont_wght.ttf')  format('truetype');
}


html, body {
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  overflow-x: hidden;

  background-color: #222129;
  background-image: radial-gradient(at 50% 20px, #1E1B26 10%, #0C0B11 100%);


}

.page {
	position: relative;
	margin: 0;
	padding: 0;
	left: 50%;
	width: calc(100% - 40px);
	max-width: 850px;
	transform: translateX(-50%);
}

* {

  font-family: 'DefaultFont';
  color: #ffffff;

  text-rendering: optimizeSpeed;

  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}


*:focus {
    outline: none;
}


button {

  $dark: 50%;
  $light: 120%;

	$height: 42px;
	$fontSize: 13px;


  background-image: linear-gradient(to right,#ffcd8e 0%,#ffbd69 100%);
  color: #111;
  font-weight: 900;
  font-size: $fontSize;
  text-transform: uppercase;


  height: $height;
  border: none;
  padding-left: 40px;
  padding-right: 40px;
  border-radius: calc(#{$height} / 2);
  cursor: pointer;

  &:disabled {
    -webkit-filter: brightness($dark);
    filter: brightness($dark);
    cursor: unset;
	pointer-events: none;

    &:hover{
      -webkit-filter: brightness($dark);
      filter: brightness($dark);
      cursor: unset;
    }
  }

  &:hover{
    -webkit-filter: brightness($light);
    filter: brightness($light);
    cursor: pointer;

    &:active {
      -webkit-filter: unset;
      filter: unset;
    }
  }

  /* shadow */
  -webkit-box-shadow: 10px 10px 21px 0px rgba(0,0,0,0.5);
  -moz-box-shadow: 10px 10px 21px 0px rgba(0,0,0,0.5);
  box-shadow: 10px 10px 21px 0px rgba(0,0,0,0.5);


	p {
		margin: 0;
		padding: 0;
		font-size: $fontSize;
		font-weight: 400;
		color: #111;
	}

}


</style>
